/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    VISUALDECK_PLANS_RECEIVE,
    VISUALDECK_PLANS_REQUEST,
    VISUALDECK_PLANS_REQUEST_SUCCESS,
    VISUALDECK_PLANS_REQUEST_FAILURE,
    CURRENT_VISUALDECK_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [VISUALDECK_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [VISUALDECK_PLANS_REQUEST]: () => true,
    [VISUALDECK_PLANS_REQUEST_SUCCESS]: () => false,
    [VISUALDECK_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [VISUALDECK_PLANS_REQUEST]: () => false,
    [VISUALDECK_PLANS_REQUEST_SUCCESS]: () => false,
    [VISUALDECK_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
